import { useContext } from "react";
import { AppContext } from "xAppLib/context";
export { useExperiment } from './useExperiment';

export function useAppHistory() {
    const { hist } = useContext(AppContext)
    return hist
}

export function useAppPresence() {
    const { prs } = useContext(AppContext)
    return prs
}

export function useSiteStatus(key) {
    const { site_status } = useContext(AppContext)
    return key ? site_status[key] : site_status
}

export function useAppNotifications() {
    const { notifications } = useContext(AppContext)
    return notifications
}

export function useAppContext(key) {
    const ctx = useContext(AppContext)
    return ctx[key]
}

// this will be good later 
export function useApp() {
    return app 
}
